import { useSelector } from 'react-redux';
import { isDefined } from '../utils';
import { getSelectedEditableAssignments } from '../instruction-hub/instruction-hub-assignments';

export default function useAssignmentsToAssign() {
  const assignmentsToAssign = useSelector((state) =>
    getSelectedEditableAssignments(
      state.CourseAssignReducer.assignments.studentAssignments,
      state.CourseAssignReducer.instructionHubBlockedLookup
    ).filter(
      (assignment) =>
        !isDefined(assignment.assignment) ||
        !isDefined(assignment.assignment.assignStatus)
    )
  );
  return assignmentsToAssign;
}



// WEBPACK FOOTER //
// ./helpers/hooks/use-assignment-to-assign.js